module.exports = __webpack_public_path__ + "static/connect2capital-logo-ecfa244f0cafa359b6495b8a37e0722f.png";